import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function MediaButton({ item, ...otherProps }) {
  const { icon, link } = item
  return (
    <a
      className="btn-social"
      href={link}
      rel={link.includes("http") ? "noopener noreferrer" : ""}
      target={link.includes("http") ? "_blank" : ""}
    >
      <FontAwesomeIcon icon={icon} size="lg" />
    </a>
  )
}
export default MediaButton
